import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'toolbar',
  styleUrls:['./toolbar.component.scss'],
  templateUrl:'toolbar.component.html'
})
export class ToolbarComponent {
  @Output() openMenu = new EventEmitter();
}



// WEBPACK FOOTER //
// ./src/app/components/toolbar/toolbar.component.ts